export default {
    title: 'Newspage',
    // Google reads name="robots"; a second googlebot tag only repeats it, and every page should carry one.
    dangerouslyDisableGooglebot: true,
    openGraph: {
        title: 'Newspage',
        type: 'website',
        locale: 'en_GB',
        url: process.env.HOST,
        images: [
            {
                url: `${process.env.HOST}/newspage.png`,
                alt: 'Newspage',
            },
        ],
    },
    twitter: {
        site: '@NewspageUK',
        cardType: 'summary',
    },
};
